/** 
 * @desc 商家页曝光埋点 
 */
export default {
  // 商家页
  sailing_c_x_shop_common_sw: 'shop_id',
  // 菜品
  sailing_c_x_realexposure_sw: 'item_id',
  // 规格选择页面
  sailing_c_x_specselection_common_sw: 'item_id',
  // 规格多层级页曝光
  sailing_c_x_specselection_hierarchy_sw: 'item_id',
}
